/*
 * @Date: 2020-03-09 21:30:19
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-10 18:12:58
 * @FilePath: /rongxin.web/src/views/home/copy-right/index.js
 */
export default {
  props: {
    color: {
      type: String,
      default: ''
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      styleObject: {
        position: 'fixed',
        bottom: '0px'
      }
    };
  },
  methods: {
  }
};
